var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NotificationsCenterCardVideo"},[_c('VideoPlayer',{attrs:{"src":_vm.mediaBackground,"customVideoStyleContainer":{
      margin: '0px'
    },"customVideoStyle":{
      height: '162px',
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }